import { GetCategories } from '../../api/category'

const state = {
  all: []
}
const getters = {
  Categories: (state) => state.all
}
const mutations = {
  populate: (state, payload) => {
    state.all = payload
  }
}
const actions = {
  RetrieveCategories: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      if (state.all.length === 0 || (typeof payload.force === 'boolean' && payload.force)) {
        GetCategories()
          .then(
            success => {
              commit('populate', success.data.items)
              resolve()
            },
            error => {
              reject(error)
            }
          )
      } else {
        resolve()
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js